import { APIService } from "../Service/API.Service";

export interface PolicyAssistantDraftRequest {
  orgId: number;
  locationId?: number;
  /** The instructions as they are now (may be empty). */
  current: string;
  /** What Swivl staff want changed or added, in plain words. */
  request: string;
}

export interface PolicyAssistantDraftResponse {
  /** The proposed full text of the custom instructions (bounded, sanitized). */
  draft: string;
  /** Anything the assistant moved, dropped, or flags as belonging elsewhere or conflicting with platform rules. */
  notes: string[];
}

export interface CallScriptTextCheckRequest {
  orgId: number;
  /** "step" = a custom step sentence; "when-to-use" = the line the bot matches a conversation against. */
  field: "step" | "when-to-use" | "agent-copy" | "completion-criteria";
  text: string;
}

export interface CallScriptTextCheckResponse {
  /** The text to save (cleaned), empty when rejected. */
  text: string;
  notes: string[];
  rejected: boolean;
}

// LINK apps/bot/src/API/PolicyAssistant/PolicyAssistant.Controller.ts
export class PolicyAssistantAPI {
  /** ENG-3356 — LLM check of one free-text call-script field before it is saved. Called by the SERVER on save (and by Studio for early feedback). */
  static async checkCallScriptText(body: CallScriptTextCheckRequest): Promise<CallScriptTextCheckResponse> {
    return APIService.Bot.post<CallScriptTextCheckResponse>("/policy-assistant/call-script-text", body);
  }

  /** ENG-3357 — the Policy Assistant drafts / tightens Swivl-staff custom instructions. Runs on the bot (it owns the LLM). */
  static async draftCustomInstructions(body: PolicyAssistantDraftRequest): Promise<PolicyAssistantDraftResponse> {
    return APIService.Bot.post<PolicyAssistantDraftResponse>("/policy-assistant/custom-instructions", body);
  }
}
